export default {

    ProformaBillRows: 'Proforma Invoice Row|Proforma Invoice Rows',
};
